module.exports = __webpack_public_path__ + "static/media/TopDelivery_2.5c8d4eb1.png";